import { Link } from "react-router-dom";
import { Clock, GraduationCap, ArrowUpRight } from "lucide-react";

const CATEGORY_LABELS = {
  "teacher-training": "Teacher Training",
  language: "Language & IELTS",
  vocational: "Vocational",
};

export default function CourseCard({ course }) {
  return (
    <Link
      to={`/admissions?course=${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className="group flex flex-col overflow-hidden rounded-3xl border border-forest/10 bg-white transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-2xl hover:shadow-forest/10"
    >
      <div className="relative h-52 overflow-hidden">
        <img
          src={course.image}
          alt={course.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <span className="absolute left-4 top-4 rounded-full bg-cream/90 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-forest backdrop-blur">
          {CATEGORY_LABELS[course.category] || course.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-serif text-2xl font-semibold leading-snug text-forest-deep">{course.title}</h3>
        <p className="mt-1 font-display text-sm font-medium text-terracotta-dark">{course.tagline}</p>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-stone-600">{course.description}</p>
        <div className="mt-5 flex items-center gap-4 border-t border-forest/10 pt-4 text-xs text-stone-500">
          <span className="flex items-center gap-1.5">
            <Clock className="h-3.5 w-3.5 text-terracotta" /> {course.duration}
          </span>
          <span className="flex items-center gap-1.5">
            <GraduationCap className="h-3.5 w-3.5 text-terracotta" /> {course.eligibility}
          </span>
          <span className="ml-auto flex items-center gap-1 font-display font-semibold text-forest">
            Apply <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </div>
    </Link>
  );
}
